import React from 'react';

import {
    Detail,
    DetailBlock,
    Label,
    LabelWrapper,
} from '~/src/components/Main/Info/ProductCard/styled';

const HeaderBlock = ({ labels, detailHandler }) => {
    return (
        <>
            <LabelWrapper>
                {
                    labels.length > 0 && labels.map((item) =>
                        <Label
                            key={item.id}
                            data-test='router-item-label'
                            color={item.color}
                        >
                            {item.title.toLowerCase()}
                        </Label>)
                }
            </LabelWrapper>
            <DetailBlock>
                {detailHandler &&
                <Detail
                    onClick={detailHandler}
                    data-test='router-item-detail'
                />
                }
            </DetailBlock>
        </>
    );
};

export default HeaderBlock;
